class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.triggerCartForLogicTwoClickedFromCartDrawer();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
      this.cartLoginToPriceButtonFunctionality();
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
        this.cartLoginToPriceButtonFunctionality();
      }
    });
  }
  triggerCartForLogicTwoClickedFromCartDrawer() {
 
    const currentPath = window.location.pathname;

    if (!(currentPath.includes("/account") || currentPath.includes("/login"))) {
      const checkIfLogicTwoCartPriceButtonWasClicked = sessionStorage.getItem(
        "login-re-direction-type"
      );

      if (
        checkIfLogicTwoCartPriceButtonWasClicked ===
        "logic-two-cart-price-button"
      ) {
        const cartLink = document.querySelector("#cart-icon-bubble");
        if (cartLink) {
          this.open(cartLink);
        }
        sessionStorage.removeItem("login-re-direction-type");
      }
    }
// document.addEventListener("DOMContentLoaded", function() {
//   setTimeout(function() {
//        console.log("testing triggerCartForLogicTwoClickedFromCartDrawer()");
      
//     const currentPath = window.location.pathname;
//     const checkForAccountPage = currentPath.includes("/account");
//     const checkForLoginPage = currentPath.includes("/login");
//     if (currentPath.includes("/account") == false || currentPath.includes("/login") == false) {
//       const checkIfLogicTwoCartPriceButtonWasClicked = sessionStorage.getItem("login-re-direction-type");

//       if (checkIfLogicTwoCartPriceButtonWasClicked === "logic-two-cart-price-button") {
//         const cartLink = document.querySelector("#cart-icon-bubble");
//         if (cartLink) {
//           // Ensure `this.open` is defined in your context
//           if (typeof this.open === 'function') {
//             this.open(cartLink);
//           } else {
//             console.error('Function `this.open` is not defined.');
//           }
//         }
//         sessionStorage.removeItem("login-re-direction-type");
//       }
//     }
//   }, 500); 
// });

  }

  cartLoginToPriceButtonFunctionality() {
  const cartlogin = document.querySelector('[cart-login]');
  if(cartlogin){
    cartlogin.addEventListener('click',function(){
      localStorage.setItem('cartLoginClick',true);
    })
  }
    const cartPriceButtons = this.querySelectorAll(
      "[price-button='logic-two-cart-price-button']"
    );
    cartPriceButtons &&
      cartPriceButtons.forEach((anchor) => {
        anchor.addEventListener("click", function (event) {
          event.preventDefault();

          sessionStorage.setItem("login-re-direction-type","logic-two-cart-price-button");
          sessionStorage.setItem("redirectAfterLoginUrl", window.location.href);

          window.location.href = this.href;
        });
      });
  }

  HideShowLoginPriceBasedOnLogic() {
    if (localStorage.getItem("customerType") == "priceCheckCustomer") {
      const product_card = document.querySelectorAll(`.product-card-wrapper`);
      const productPageProduct = document.querySelectorAll(
        ".product__info-wrapper"
      );
      const cart_product_items = document.querySelectorAll(".cart-item");
      if (product_card) {
        product_card.forEach((card) => {
          card.classList.remove("hide_price_based_on_logic");
          card.classList.add("show_price_based_on_logic");
        });
      }
      if (productPageProduct) {
        productPageProduct.forEach((product) => {
          product.classList.remove("hide_price_based_on_logic");
          product.classList.add("show_price_based_on_logic");
        });
      }
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      setTimeout(()=> {

        this.cartLoginToPriceButtonFunctionality();
      },1000)
      // this.cartLoginToPriceButtonFunctionality();
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    this.HideShowLoginPriceBasedOnLogic();
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
